import { render } from "./AllTileGameContent.vue?vue&type=template&id=69067afb"
import script from "./AllTileGameContent.vue?vue&type=script&lang=js"
export * from "./AllTileGameContent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__